import { faker } from '@faker-js/faker';
import { generateFromEnum, generateInitialPaginationApi } from '@ingenico/api-sdk-core/mocks';
import type {
  ApplicationResourceReadV2Api,
  ApplicationVersionStatusResourceReadV2Api,
  GetApplicationArtifactsByApplicationIdV2QueryResponseApi,
  GetApplicationByIdV2QueryResponseApi,
  SearchApplicationsV2MutationResponseApi,
  SoftwareVersionArtifactResourceReadV2Api,
  TemplateResourceListResponseV2Api,
} from '@ingenico/api-sdk-device-management-private-v2';
import {
  enumApplicationTypeV2,
  enumArtifactComponentType,
  enumArtifactType,
  enumAssetTypeV2,
  enumVersionPublicationStatus,
} from '@ingenico/api-sdk-device-management-private-v2';
import { HttpResponse } from 'msw';
import { generateTemplateResourceReadV2Api } from './common';
import { MOCKED_USER_ORGANIZATION_ID } from '../../directory-private-local/directory-private-local';

export function searchApplicationsV2CustomHandler() {
  const count = faker.number.int({ min: 1, max: 9 });

  const applicationVersions: SearchApplicationsV2MutationResponseApi = {
    pagination: generateInitialPaginationApi(count),
    data: faker.helpers.multiple((_, index) => generateApplicationResourceReadV2Api(index + 1), { count }),
  };

  return HttpResponse.json<SearchApplicationsV2MutationResponseApi>(applicationVersions);
}
const DISTINCT_APPLICATION_ID = '88452336-0000-0000-0000-62f9d6617625';

function generateApplicationVersionStatusResourceReadV2Api(
  opt?: Partial<ApplicationVersionStatusResourceReadV2Api>,
): Required<ApplicationVersionStatusResourceReadV2Api> {
  return {
    applicationVersionId: faker.string.uuid(),
    status: generateFromEnum(enumVersionPublicationStatus),
    versionNumber: faker.system.semver(),
  };
}
function generateApplicationResourceReadV2Api(index?: number): ApplicationResourceReadV2Api {
  return {
    id: index ? `${index}60e086a-fe60-4afb-a01e-03ef74c15d3f` : faker.string.uuid(),
    name: index ? `App${index}` : faker.commerce.product(),
    shortDescription: faker.commerce.productAdjective(),
    longDescription: faker.commerce.productDescription(),
    // status: faker.helpers.arrayElement(Object.values(enumVersionPublicationStatus)),
    status: enumVersionPublicationStatus.PUBLISHED,
    creationDate: faker.date.past(),
    assets: faker.helpers.multiple(
      () => ({
        type: enumAssetTypeV2.LOGO,
        id: faker.string.uuid(),
      }),
      { count: 2 },
    ),
    provider: {
      // id: faker.helpers.arrayElement([DISTINCT_APPLICATION_ID, MOCKED_USER_ORGANIZATION_ID]),
      id: MOCKED_USER_ORGANIZATION_ID, //Must match the user parent id mocked
      name: faker.company.name(),
      location: {
        country: faker.location.countryCode(),
        city: faker.location.city(),
      },
    },
    compatibleDeviceFamilyNames: [faker.helpers.arrayElement(['AXIUM', 'MOVE', 'LINK'])],
    publisherId: 'd934dc1e-9c65-486d-a2dc-bfbda4772c6d',
    type: faker.helpers.arrayElement(Object.values(enumApplicationTypeV2)),
    applicationVersions: faker.helpers.multiple(
      () => generateApplicationVersionStatusResourceReadV2Api({ status: enumVersionPublicationStatus.DEPRECATED }),
      {
        count: faker.number.int({ min: 1, max: 6 }),
      },
    ),
    publishedVersionNumbers: faker.helpers.multiple(faker.system.semver, {
      count: faker.number.int({ min: 1, max: 3 }),
    }),
  };
}

export function getApplicationByIdV2ResponseMock(): GetApplicationByIdV2QueryResponseApi {
  return generateApplicationResourceReadV2Api();
}

export function getApplicationArtifactsByApplicationIdV2ResponseMock(): GetApplicationArtifactsByApplicationIdV2QueryResponseApi {
  const count = faker.number.int({ min: 10, max: 75 });
  return {
    pagination: generateInitialPaginationApi(count),
    data: faker.helpers.multiple(generateSoftwareVersionArtifactResourceReadV2Api, { count }),
  };
}
function generateSoftwareVersionArtifactResourceReadV2Api(): SoftwareVersionArtifactResourceReadV2Api {
  return {
    id: faker.string.uuid(),
    type: faker.helpers.arrayElement(Object.values(enumArtifactType)),
    checksum: faker.string.uuid(),
    componentType: faker.helpers.arrayElement(Object.values(enumArtifactComponentType)),
    mimeType: faker.system.mimeType(),
    size: faker.number.int({ min: 100, max: 10_000 }),
    fileName: faker.system.fileName(),
    createdBy: faker.string.uuid(),
    creationDate: faker.date.past(),
    extension: faker.system.fileExt(),
    order: faker.number.int({ min: 1000, max: 5000 }),
  };
}

export function getApplicationTemplatesByApplicationIdV2ResponseMock(): TemplateResourceListResponseV2Api {
  const count = faker.number.int({ min: 2, max: 10 });
  return {
    pagination: generateInitialPaginationApi(count),
    data: faker.helpers.multiple(() => generateTemplateResourceReadV2Api(), { count }),
  };
}
